'use client'

import React, { useState } from 'react'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, BoxProps, Text } from '@chakra-ui/react'

import { ButtonSecondary } from '../Buttons/Button'
import { ToggleExpandButton } from '../ToggleExpandButton'

import { AccordionContent, AccordionContentWrapper, AccordionHeader, AccordionWrapper } from './styles'

type Props = {
  title: React.ReactNode
  collapsedHeight?: number
  children: NonNullable<React.ReactNode>
} & BoxProps

export const Accordion: React.FC<Props> = ({ title, collapsedHeight = 100, children, ...otherProps }) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggleAccordion = () => {
    setIsExpanded((prev) => !prev)
  }

  return (
    <AccordionWrapper padding="20px" {...otherProps}>
      <AccordionHeader>
        <Box display="flex" justifyContent="space-between" alignItems="center" padding="10px" width="100%">
          <Text fontSize="sm" fontWeight={700}>
            {title}
          </Text>
          <ToggleExpandButton isExpanded={isExpanded} onClick={toggleAccordion} />
        </Box>
      </AccordionHeader>
      <AccordionContentWrapper
        expandedHeight={
          contentRef.current?.scrollHeight
            ? // increase maxHeight just a little bit to prevent cutting margins, borders etc.
              contentRef.current?.scrollHeight + 30
            : 0
        }
        collapsedHeight={collapsedHeight}
        isExpanded={isExpanded}
      >
        <AccordionContent ref={contentRef}>
          <Box padding="10px">{children}</Box>
        </AccordionContent>
      </AccordionContentWrapper>
      <ButtonSecondary onClick={toggleAccordion}>{isExpanded ? t('showLess') : t('showMore')}</ButtonSecondary>
    </AccordionWrapper>
  )
}
